import React from 'react';

import fetch from './fetch';

import moment from 'moment';

import utils from '../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},
    {key:'columnName1', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName2', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName3', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName4', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName5', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName6', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName7', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName8', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName9', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName10', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName11', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName12', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName13', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName14', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName15', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName16', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName17', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName18', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName19', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName20', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName21', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName22', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName23', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName24', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName25', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName26', label: '未知列', width: 140, renderType: "select"},
    {key:'checkFlag', label: '数据状态', width: 150, render: (value)=> {
        if(+value === 1) {
            return '未检查'
        } else if(+value === 0) {
            return '检查通过'
        } else if(+value === 2) {
            return <span className="root-unchecked">检查不通过</span>
        }
        return '';
    }},
    {key:'errorDesc', label: '数据描述', width: 220},
]);

/**
 * @method querySearchByName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByName = (keywords ={}) => {
    return fetch.post('classes/find', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.classesId,
            label: d.classesName
        }));
    });
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('classes/get/'+ id, {})
    .then(response => response.payload.data);
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('excel/result/list/'+ keywords.pageSize, keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta.extParams
        };
    })
    .then(response => (Object.assign({
        result: response.data.dataList || [],
        selects: (response.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: response.data.total,
        pageIndex: response.data.pageNum,
        pageSize:response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...',
        meta: response.meta
    })));
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('classes/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '提示信息!',
                content: (
                    <div>
                        <p>{response.message}</p>
                    </div>
                ),
                onOk() {
                    window.location.hash = 'classes/index';
                },
                okText:"确认",
            });
        }
        return response;
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('classes/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '提示信息!',
                content: (
                    <div>
                        <p>{response.message}</p>
                    </div>
                ),
                onOk() {
                    window.location.hash = 'classes/index';
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('classes/remove/', ids)
    .then(response => {
        return response;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.refresh();
                            },
                        })
                    }
                    ;
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'classes'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

export default {
    insertURL: '#/classes/insert',
    querySearchByName,
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection: () => DataGrid.selections 
}